module.exports = __webpack_public_path__ + "img/image1.fb2996bd.jpg";